import { render, staticRenderFns } from "./TransportOrderEdit.vue?vue&type=template&id=1c5a7163&scoped=true"
import script from "./TransportOrderEdit.vue?vue&type=script&lang=js"
export * from "./TransportOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a7163",
  null
  
)

export default component.exports